import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Common/Loader";

const csvTemplateUrl = "/sample_lead.csv";
import { Spinner } from "react-bootstrap";
import {
  getImportLeadsAction,
  createImportLeadsAction,
  updateImportLeadsAction,
} from "../../../../store/actions/ImportLeadAction";
import { getDiseasesAction } from "../../../../store/actions/DiseasesAction";

const ImportLeads = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});

  // Fix the selector to handle undefined state
  const importLeadsState = useSelector((state) => state.importLeads || {});
  const importLeads = importLeadsState.importLeads || [];
  const num_rows = importLeadsState.num_rows || 0;
  const diseases = useSelector((state) => state.diseases.diseases || [""]);

  // Modal and form states
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);

  // Form data states
  const [formData, setFormData] = useState({
    campaign_type: "",
    social_media_type: "",
    import_file: null,
    disease_id: "",
  });

  // Search and filter states
  const [searchQueries, setSearchQueries] = useState({
    campaign_type: "",
    social_media_type: "",
    filename: "",
  });

  // Pagination and sorting states
  const [currentPage, setCurrentPage] = useState(0);
  const [sortField, setSortField] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const rowsPerPage = 10;

  // Track active search for server-side filtering
  const [activeSearchField, setActiveSearchField] = useState("");
  const [activeSearchKeyword, setActiveSearchKeyword] = useState("");

  const fileInputRef = useRef(null);

  // Map UI fields to actual DB columns for search and sort
  const fieldToDbMap = {
    campaign_type: "campaign_type",
    social_media_type: "social_media_type",
    filename: "import_file", // Assuming API expects 'import_file' for filename search
    created_at: "created_at",
    disease_id: "disease_id",
  };

  // Fetch import leads and diseases on component mount
  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     setError("");
  //     try {
  //       await Promise.all([
  //         fetchImportLeadsFromServer("", "", fieldToDbMap[sortField], sortOrder, true, 0),
  //         dispatch(getDiseasesAction()),
  //       ]);
  //     } catch (err) {
  //       console.error("Failed to fetch data:", err);
  //       setError("Failed to load data. Please try again.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, [dispatch]);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError("");
      try {
        await Promise.all([
          fetchImportLeadsFromServer("", "", fieldToDbMap[sortField], sortOrder, true, 0),
          dispatch(getDiseasesAction(false)),
        ]);
      } catch (err) {
        console.error("Failed to fetch data:", err);
        setError("Failed to load data. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dispatch]);

  // const fetchImportLeadsFromServer = async (
  //   search_by = "",
  //   search_keyword = "",
  //   sort_by = sortField,
  //   sort_order = sortOrder,
  //   pagination = true,
  //   pageid = 0
  // ) => {
  //   try {
  //     await dispatch(
  //       getImportLeadsAction(pagination, pageid, search_by, search_keyword, sort_by, sort_order)
  //     );
  //   } catch (err) {
  //     console.error("Failed to fetch import leads:", err);
  //     setError("Failed to load import leads. Please try again.");
  //   }
  // };
  const fetchImportLeadsFromServer = async (
    search_by = "",
    search_keyword = "",
    sort_by = "",
    sort_order = "",
    pagination = true,
    pageid = 0
  ) => {
    try {
      // setLoading(true);
      await dispatch(
        getImportLeadsAction(
          pagination,
          pageid,
          search_by,
          search_keyword,
          sort_by,
          sort_order
        )
      );
    } catch (err) {
      console.error("Failed to fetch import leads:", err);
      setError("Failed to load import leads. Please try again.");
    } finally {
      // setLoading(false);
    }
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    const currentSortDbField = fieldToDbMap[sortField] || sortField;
    fetchImportLeadsFromServer(
      activeSearchField,
      activeSearchKeyword,
      currentSortDbField,
      sortOrder,
      true,
      page
    );
  };

  // Handle search functionality - Modified to clear other fields
  // const handleSearch = (event, field) => {
  //   const keyword = event.target.value;
  
  //   // Clear other search fields
  //   const clearedQueries = { campaign_type: "", social_media_type: "", filename: "" };
  //   const updatedQueries = { ...clearedQueries, [field]: keyword };
  //   setSearchQueries(updatedQueries);
  //   setCurrentPage(0);
  
  //   const dbField = fieldToDbMap[field] || field;
  
  //   // Save active search state
  //   setActiveSearchField(dbField);
  //   setActiveSearchKeyword(keyword);
  
  //   // Determine if sorting is active
  //   const hasSorting = sortField && sortOrder;
  //   fetchImportLeadsFromServer(
  //     dbField,
  //     keyword,
  //     hasSorting ? fieldToDbMap[sortField] || sortField : "",
  //     hasSorting ? sortOrder : "",
  //     true,
  //     0
  //   );
  // };
  const handleSearch = (event, field) => {
    const keyword = event.target.value.trim();
    
    // Update the search query state
    setSearchQueries(prev => ({ ...prev, [field]: keyword }));
    setCurrentPage(0);
  
    // Map the UI field to backend field
    const backendFieldMap = {
      filename: 'import_file', // Maps to filename search in backend
      campaign_type: 'campaign_type',
      social_media_type: 'social_media_type'
    };
    
    const backendField = backendFieldMap[field] || field;
    
    // Fetch with the search parameters
    fetchImportLeadsFromServer(
      backendField,
      keyword,
      fieldToDbMap[sortField] || sortField,
      sortOrder,
      true,
      0
    );
  };
  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    const dbField = fieldToDbMap[field] || field;
    
    setSortField(field);
    setSortOrder(order);
  
    // Get current active search (if any)
    const activeField = Object.keys(searchQueries).find(key => searchQueries[key]);
    const searchField = activeField ? fieldToDbMap[activeField] || activeField : "";
    const searchKeyword = activeField ? searchQueries[activeField] : "";
  
    fetchImportLeadsFromServer(
      searchField,
      searchKeyword,
      dbField,
      order,
      true,
      currentPage
    );
  };
  
  

  // Handle sorting functionality
  // const handleSort = (field) => {
  //   const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
  //   const newSortDbField = fieldToDbMap[field] || field;
    
  //   setSortField(field);
  //   setSortOrder(order);
  
  //   fetchImportLeadsFromServer(
  //     activeSearchField || "",
  //     activeSearchKeyword || "",
  //     newSortDbField,
  //     order,
  //     true,
  //     currentPage
  //   );
  // };


  // Get filename from URL
  const getFileName = (url) => {
    if (!url || typeof url !== "string") return "N/A";
    const trimmedUrl = url.trim().replace(/\/+$/, "");
    const parts = trimmedUrl.split("/");
    return parts.length ? parts[parts.length - 1] : "N/A";
  };

  // Server already returns paginated data
  const paginatedData = importLeads;
  const totalPages = Math.ceil(num_rows / rowsPerPage);

  // Handle file change with CSV validation
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file
      if (!file.name.toLowerCase().endsWith(".csv")) {
        alert("Please select a CSV file only!");
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        alert("File size must be under 10MB!");
        return;
      }
      // Set as File object
      setFormData((prev) => ({
        ...prev,
        import_file: file,
      }));
    }
  };

  // Handle input changes
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // Open modal for adding new lead
  const handleAddClick = () => {
    setIsEditMode(false);
    setSelectedLeadId(null);
    setFormData({
      campaign_type: "Health",
      social_media_type: "Facebook",
      import_file: null,
      disease_id: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setShowModal(true);
  };

  // Open modal for editing existing lead
  const handleEditClick = (lead) => {
    setIsEditMode(true);
    setSelectedLeadId(lead.import_lead_id || lead.importLead_id);
    setFormData({
      campaign_type: lead.campaign_type,
      social_media_type: lead.social_media_type,
      import_file: null,
      disease_id: lead.disease_id,
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setShowModal(true);
  };

  // Handle download CSV file
  const handleDownloadClick = (fileUrl, fileName) => {
    if (fileUrl) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileName || "import_file.csv";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert("File not available for download!");
    }
  };

  // Handle CSV template view in new tab
  const handleViewCsvTemplate = () => {
    window.open(csvTemplateUrl, "_blank", "noopener,noreferrer");
  };

  // Handle form submission
  const handleSave = async () => {
    const newErrors = {};
    if (!isEditMode && !formData.import_file) {
      alert("Please select a CSV file!");
      return;
    }
    if (!formData.campaign_type || !formData.social_media_type) {
      alert("Please fill all required fields!");
      return;
    }
    if (!formData.disease_id) {
      newErrors.disease_id = "Please select disease.";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setLoading(true); 
    try {
      if (isEditMode) {
        await dispatch(updateImportLeadsAction(formData, selectedLeadId));
      } else {
        await dispatch(createImportLeadsAction(formData));
      }

      // Refresh the current page after save
      const currentSortDbField = fieldToDbMap[sortField] || sortField;
      await fetchImportLeadsFromServer(
        activeSearchField,
        activeSearchKeyword,
        currentSortDbField,
        sortOrder,
        true,
        currentPage
      );

      setShowModal(false);
      setFormData({
        campaign_type: "Health",
        social_media_type: "Facebook",
        import_file: null,
        disease_id: "",
      });
      setErrors({});
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Failed to save import lead:", error);
    }
    finally {
      setLoading(false); // ✅ stop loader
    }
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      campaign_type: "Health",
      social_media_type: "Facebook",
      import_file: null,
      disease_id: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString || dateString === "0000-00-00 00:00:00") return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  // Add a function to get disease name by ID
  const getDiseaseNameById = (diseaseId) => {
    if (!diseaseId) return "Not specified";
    const disease = diseases.find((d) => d.disease_id === diseaseId);
    return disease ? disease.disease_name : "Unknown";
  };

  return (
    <>
      {/* Header with Add Button */}
      <div className="row mb-3">
        <div className="col-xl-12 text-end">
          <button
            className="btn btn-primary btn-rounded add-lead"
            onClick={handleAddClick}
            disabled={loading}
          >
            + Import Leads
          </button>
        </div>
      </div>

      {/* Main Table */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              {error && <div className="text-danger mb-2">{error}</div>}
              {loading ? (
                <div className="text-center my-5">
                  <Loader size="lg" />
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-striped table-bordered table-hover mb-4">
                      <thead className="table-light">
                        <tr>
                          <th onClick={() => handleSort("created_at")} style={{ cursor: "pointer" }}>
                            Upload Date{" "}
                            {sortField === "created_at" && (sortOrder === "asc" ? "↑" : "↓")}
                          </th>
                          <th onClick={() => handleSort("filename")} style={{ cursor: "pointer" }}>
                            Filename{" "}
                            {sortField === "filename" && (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.filename}
                              onChange={(e) => handleSearch(e, "filename")}
                              onClick={(e) => e.stopPropagation()} 
                              placeholder="Search filename"
                            />
                          </th>
                          <th onClick={() => handleSort("campaign_type")} style={{ cursor: "pointer" }}>
                            Campaign Type{" "}
                            {sortField === "campaign_type" && (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.campaign_type}
                              onChange={(e) => handleSearch(e, "campaign_type")}
                              onClick={(e) => e.stopPropagation()} 
                              placeholder="Search campaign"
                            />
                          </th>
                          <th onClick={() => handleSort("social_media_type")} style={{ cursor: "pointer" }}>
                            Social Media Type{" "}
                            {sortField === "social_media_type" && (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.social_media_type}
                              onChange={(e) => handleSearch(e, "social_media_type")}
                                onClick={(e) => e.stopPropagation()} 
                              placeholder="Search social media"
                            />
                          </th>
                          <th onClick={() => handleSort("disease_id")} style={{ cursor: "pointer" }}>
                            Disease{" "}
                            {sortField === "disease_id" && (sortOrder === "asc" ? "↑" : "↓")}
                          </th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.length > 0 ? (
                          paginatedData.map((lead) => (
                            <tr key={lead.import_lead_id || lead.importLead_id}>
                              <td>{formatDate(lead.created_at)}</td>
                              <td>{getFileName(lead.import_file)}</td>
                              <td>{lead.campaign_type}</td>
                              <td>{lead.social_media_type}</td>
                              <td>{getDiseaseNameById(lead.disease_id)}</td>
                              <td>
                                <div className="d-flex flex-nowrap gap-2 align-items-center">
                                  <span
                                    className="text-success"
                                    onClick={() => handleEditClick(lead)}
                                    style={{ cursor: "pointer" }}
                                    title="Edit Lead"
                                  >
                                    <i className="fa fa-pencil-alt fs-18" />
                                  </span>
                                  <span
                                    className="text-primary"
                                    onClick={() =>
                                      handleDownloadClick(lead.import_file, getFileName(lead.import_file))
                                    }
                                    style={{ cursor: "pointer" }}
                                    title="Download File"
                                  >
                                    <i className="fa fa-download fs-18" />
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center py-4">
                              {loading ? "Loading..." : "No import leads found"}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div
                    className="pagination-wrapper"
                    style={{
                      display: "flex",
                      gap: "6px",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "20px",
                      flexWrap: "wrap",
                      flexDirection: "column",
                    }}
                  >
                    <div>
                      Showing {importLeads?.length === 0 ? 0 : currentPage * rowsPerPage + 1} to{" "}
                      {Math.min((currentPage + 1) * rowsPerPage, num_rows)} of {num_rows} entries
                    </div>
                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", justifyContent: "center" }}>
                      <button
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                        disabled={currentPage === 0}
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          color: "#000",
                          cursor: currentPage === 0 ? "not-allowed" : "pointer",
                          opacity: currentPage === 0 ? 0.5 : 1,
                        }}
                      >
                        &lt;
                      </button>
                      {(() => {
                        const pages = [];
                        const maxPagesToShow = 5;
                        const startPage = Math.max(
                          0,
                          Math.min(currentPage - 2, totalPages - maxPagesToShow)
                        );
                        const endPage = Math.min(startPage + maxPagesToShow, totalPages);

                        if (startPage > 0) {
                          pages.push(
                            <button
                              key={0}
                              onClick={() => handlePageChange(0)}
                              style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                color: "#000",
                                cursor: "pointer",
                              }}
                            >
                              1
                            </button>
                          );
                          if (startPage > 1) {
                            pages.push(
                              <span key="dots1" style={{ padding: "6px 12px", userSelect: "none" }}>
                                ...
                              </span>
                            );
                          }
                        }

                        for (let i = startPage; i < endPage; i++) {
                          const isActive = currentPage === i;
                          pages.push(
                            <button
                              key={i}
                              onClick={() => handlePageChange(i)}
                              style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: isActive ? "#007bff" : "#fff",
                                color: isActive ? "#fff" : "#000",
                                cursor: "pointer",
                              }}
                            >
                              {i + 1}
                            </button>
                          );
                        }

                        if (endPage < totalPages) {
                          if (endPage < totalPages - 1) {
                            pages.push(
                              <span key="dots2" style={{ padding: "6px 12px", userSelect: "none" }}>
                                ...
                              </span>
                            );
                          }
                          pages.push(
                            <button
                              key={totalPages - 1}
                              onClick={() => handlePageChange(totalPages - 1)}
                              style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                color: "#000",
                                cursor: "pointer",
                              }}
                            >
                              {totalPages}
                            </button>
                          );
                        }

                        return pages;
                      })()}
                      <button
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))}
                        disabled={currentPage === totalPages - 1}
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          color: "#000",
                          cursor: currentPage === totalPages - 1 ? "not-allowed" : "pointer",
                          opacity: currentPage === totalPages - 1 ? 0.5 : 1,
                        }}
                      >
                        &gt;
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Add/Edit */}
      <Modal centered show={showModal} onHide={handleCloseModal} size="lg">
        <div className="modal-header">
          <h5 className="modal-title">{isEditMode ? "Edit Import Lead" : "Add Import Lead"}</h5>
          <button type="button" className="btn-close" onClick={handleCloseModal}></button>
        </div>
        <div className="modal-body">
          <form>
            <div className="row">
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label className="col-form-label">
                    Campaign Type: <span className="text-danger">*</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <select
                      className="form-control"
                      value={formData.campaign_type}
                      onChange={(e) => handleInputChange("campaign_type", e.target.value)}
                      style={{
                        paddingRight: "30px",
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                      }}
                    >
                      <option value="Health">Health</option>
                      <option value="Wellness">Wellness</option>
                      <option value="Fitness">Fitness</option>
                      <option value="Beauty">Beauty</option>
                      <option value="Education">Education</option>
                    </select>
                    <i
                      className="fa fa-caret-down"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label className="col-form-label">
                    Social Media Type: <span className="text-danger">*</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <select
                      className="form-control"
                      value={formData.social_media_type}
                      onChange={(e) => handleInputChange("social_media_type", e.target.value)}
                      style={{
                        paddingRight: "30px",
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                      }}
                    >
                      <option value="Facebook">Facebook</option>
                      <option value="Instagram">Instagram</option>
                      <option value="Twitter">Twitter</option>
                      <option value="LinkedIn">LinkedIn</option>
                      <option value="YouTube">YouTube</option>
                    </select>
                    <i
                      className="fa fa-caret-down"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label className="col-form-label">
                    File: {!isEditMode && <span className="text-danger">*</span>}
                    {isEditMode && <span className="text-muted">(Not editable)</span>}
                  </label>
                  <input
                    ref={fileInputRef}
                    type="file"
                    className="form-control"
                    accept=".csv"
                    onChange={handleFileChange}
                    disabled={isEditMode}
                  />
                  {formData.import_file && (
                    <small className="form-text text-success">
                      Selected file: {formData.import_file.name}
                    </small>
                  )}
                  {isEditMode && <small className="form-text text-info">File cannot be changed</small>}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label className="col-form-label">
                    Select Disease:<span className="text-danger">*</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <select
                      className="form-control"
                      value={formData.disease_id}
                      onChange={(e) => handleInputChange("disease_id", e.target.value)}
                      style={{
                        paddingRight: "30px",
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                      }}
                    >
                      <option value="">Choose a disease</option>
                      {diseases.map((disease) => (
                        <option key={disease.disease_id} value={disease.disease_id}>
                          {disease.disease_name}
                        </option>
                      ))}
                    </select>
                    <i
                      className="fa fa-caret-down"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    ></i>
                  </div>
                  {errors.disease_id && <small className="text-danger">{errors.disease_id}</small>}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label className="col-form-label">&nbsp;</label>
                  <div>
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={handleViewCsvTemplate}
                      disabled={isEditMode}
                      title="View CSV Template"
                    >
                      <i className="fa fa-file-csv" style={{ marginRight: "8px" }}></i>
                      Sample File
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
            Close
          </button>
          {/* <button type="button" className="btn btn-primary" onClick={handleSave} disabled={loading}>
            {loading ? "Saving..." : isEditMode ? "Update" : "Save"}
          </button> */}
            <button
        type="button"
        className="btn btn-primary"
        onClick={handleSave}
        disabled={loading}
      >
        {loading ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            {isEditMode ? "Updating..." : "Saving..."}
          </>
        ) : (
          isEditMode ? "Update" : "Save"
        )}
      </button>
        </div>
      </Modal>
    </>
  );
};

export default ImportLeads;
